<template>
  <div
    class="tag-wrapper"
    v-click-outside="closeEdit"
    @click="showTable = true"
    @mouseleave="!clickedOnDateChange ? (showTable = false) : ''"
  >
    <span class="label tag-referral table-tag-content">
      <!--      @click="filterMain"-->
      <span class="tagNameDesign">RF</span>
      {{ formatDate(referrals[0].created_at) }}
      <span class="forNumOutOfName" v-if="referrals.length > 1">{{
        referrals.length
      }}</span>
      <a @click.prevent="$emit('delete')"
        ><span v-if="showRemove" class="fas fa-times remove-tag-icon"></span></a
    ></span>

    <div v-if="showTable" class="tag-table pop-up-for-tags">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th class="t-header">DATE</th>
              <th class="t-header">TIME</th>
              <th class="t-header">BROKER</th>
              <th class="t-header">AGENT</th>
              <th>
                <i
                  class="fa fa-times"
                  aria-hidden="true"
                  @mouseenter="showTable = false"
                ></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="ref in referrals" :key="ref.id">
              <!--              normal date mode-->
              <td
                :class="{
                  inBetweenSelectedCalDates: checkSelectedCalDates(ref)
                }"
                v-show="
                  requestForDate.tagName !== 'rf' ||
                    requestForDate.id !== ref.id
                "
              >
                {{ formatDateTable(ref.created_at) }}
                <i
                  v-if="
                    requestForDate.date == null || requestForDate.time == null
                  "
                  class="fas fa-edit clickable"
                  @click="[sendVuexToCal(ref), (clickedOnDateChange = true)]"
                ></i>
                <i
                  @click="sendNewDateFromPopUpToDB"
                  class="fas fa-check pointer"
                  v-if="
                    requestForDate.date != null &&
                      requestForDate.time != null &&
                      requestForDate.id === ref.id
                  "
                ></i>
              </td>
              <!--              edit date mode-->
              <td
                v-show="
                  requestForDate &&
                    requestForDate.tagName === 'rf' &&
                    requestForDate.id === ref.id
                "
                class="text-danger"
              >
                <i
                  v-if="
                    requestForDate.date == null || requestForDate.time == null
                  "
                  class="fas fa-window-close clickable"
                  @click="[sendVuexToCal(), (clickedOnDateChange = true)]"
                ></i>
                <i
                  @click="sendNewDateFromPopUpToDB"
                  class="fas fa-check pointer"
                  v-if="
                    requestForDate.date != null &&
                      requestForDate.time != null &&
                      requestForDate.id === ref.id
                  "
                ></i>
                {{ textOrDate }}
              </td>
              <!--              end edit date mode-->
              <td
                :class="{
                  inBetweenSelectedCalDates: checkSelectedCalDates(ref)
                }"
              >
                <span
                  class="text-danger"
                  v-if="
                    requestForDate.date != null &&
                      requestForDate.time != null &&
                      requestForDate.id === ref.id
                  "
                  >{{ requestForDate.time }}:00</span
                >
                <span v-else>{{ ref.created_at | shortTime }}</span>
              </td>
              <td>{{ ref.campaign.name }}</td>
              <td class="d-none">{{ formatDate(ref.payment_on) }}</td>
              <td>{{ ref.user.full_name }}</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import vClickOutside from "v-click-outside";
import { mapState } from "vuex";
import apiClientCreator from "../../../../../../helpers/api/request";

export default {
  name: "Referral",
  directives: {
    clickOutside: vClickOutside.directive
  },
  computed: {
    ...mapState("clients", ["requestForDate", "generalQueryObject"])
  },
  props: {
    referrals: {
      type: Array,
      required: true
    },
    showRemove: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      showTable: false,
      textOrDate: "Choose date",
      clickedOnDateChange: false,
      recId: null,
      tagName: null,
      newDate: null,
      newHours: null,
      total: null
    };
  },
  watch: {
    requestForDate: function() {
      if (this.requestForDate.time != null) {
        this.textOrDate =
          this.requestForDate.date + " " + this.requestForDate.time;
      }
      if (this.requestForDate.date != null) {
        this.textOrDate = this.requestForDate.date;
      }
      if (
        this.requestForDate.direction === "FROM_CAL" &&
        this.requestForDate.id === this.editId &&
        this.requestForDate.tagName === "rf"
      ) {
        this.recId = this.requestForDate.id;
        this.tagName = this.requestForDate.tagName;
        this.newDate = this.requestForDate.date;
        this.newHours = this.requestForDate.time;
        this.total = moment(
          `${this.newDate} ${this.newHours}`,
          "YYYY-MM-DD HH:mm:ss"
        ).format("YYYY-MM-DD HH:mm:ss");
        this.editId = null;
      }
    }
    // "FilterFromMainCal.fromWhere": function() {
    //   if (this.setFilterFromMainCal.fromWhere !== "MainCal") {
    //     this.textOrDate = "Choose In Main Cal";
    //   } else {
    //     this.textOrDate = "";
    //   }
    // }
  },
  methods: {
    sendNewDateFromPopUpToDB() {
      const apiUpdatedDate = apiClientCreator(
        `client/updatedDateFromPopUp/${this.recId}`
      );
      apiUpdatedDate
        .post("", {
          updated_at: this.total,
          tag_name: this.tagName
        })
        .then(e => {
          this.$emit("updated");
          this.clickedOnDateChange = false;
          this.$store.commit("clients/setRequestForDate", {});
        });
    },
    checkSelectedCalDates(rfDit) {
      let rfIn = moment(rfDit.created_at);
      let start = moment(this.generalQueryObject.last_referral_from).startOf(
        "day"
      );
      let to = moment(this.generalQueryObject.last_referral_to).endOf("day");
      if (rfIn.isBetween(start, to)) {
        return true;
      } else {
        return false;
      }
    },
    sendVuexToCal(ref = null) {
      if (ref) {
        this.editId = ref.id;
        this.$store.commit("clients/setRequestForDate", {
          tagName: "rf",
          fromWhere: "referral",
          calendar: "REF",
          id: ref.id,
          direction: "FROM_TAG"
        });
      } else {
        this.$store.commit("clients/setRequestForDate", {});
      }
    },
    closeEdit() {
      if (
        this.requestForDate.direction !== "FROM_TAG" &&
        this.requestForDate.id !== this.editId &&
        this.requestForDate.date == null &&
        this.requestForDate.time == null
      ) {
        this.showTable = false;
        this.recId = null;
        this.tagName = null;
        this.newDate = null;
        this.newHours = null;
        this.total = null;
      }
    },
    // filterMain() {
    //   this.$store.commit("clients/setFilterToMain", {
    //     title: "rf",
    //     type: true
    //   });
    // },
    formatDate(date) {
      return moment(String(date)).format("HH:mm DD/MM");
    },
    formatDateTable(date) {
      return moment(String(date)).format("DD/MM ");
    }
  }
};
</script>

<style lang="scss" scoped>
.tag-wrapper {
  display: inline-flex;
  position: relative;
}

.tag-referral {
  background-color: #af3131;
  /*font-size: 12px;*/
  /*color: white;*/
  /*!*font-size: 11px;*!*/
  /*margin: 2px;*/
  /*!*padding: 3px;*!*/
  /*line-height: 2;*/
  /*cursor: pointer;*/
  /*font-family: Montserrat !important;*/
  /*font-weight: 500;*/
  /*animation: flash linear 1s;*/
}

@keyframes flash {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 3;
  }
}

.tag-table {
  bottom: 34px;
  border: solid 1px #ac3130;
  text-align: center;
  max-height: 267px;
  overflow-y: hidden;
}

.table-responsive {
  margin-bottom: 0px;
  border-radius: 5px;
  max-height: 267px;
  overflow: auto;
}

.table {
  margin-bottom: 0px !important;
}

.tag-time {
  font-size: 8pt;
}

.remove-tag-icon {
  /*color: white;*/
  /*cursor: pointer;*/
  /*margin-left: 5px;*/
  color: white;
  cursor: pointer;
  margin-left: 0px;
  position: absolute;
  left: 11px;
  font-size: 17px;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 6px;
  padding-right: 6px;
  border: 1px solid black;
  border-radius: 5px;
  top: 6px;
  background: black;
}
.remove-tag-icon:hover {
  color: white;
  background: black;
}
/*.remove-tag-icon:hover {*/
/*  color: #f44336;*/
/*}*/
.label {
  padding: 4px 2px 4px 2px;
  font-size: 12px;
}
.tagNameDesign:hover {
  font-size: 12.3px !important;
}
.forNumOutOfName {
  font-weight: 100;
}
.d-none {
  display: none;
}
.clickable {
  color: lightskyblue;
}
.clickable:hover {
  cursor: pointer;
}
.tagNameDesign {
  margin-left: 3px !important;
  font-size: 11.5px !important;
  padding: 3px !important;
}
.inBetweenSelectedCalDates {
  color: blue;
}
tbody > tr:nth-of-type(odd) {
  background-color: #7a7a7a0d;
}
.t-header {
  position: sticky;
  top: 0;
  background-color: white !important;
}
.pointer {
  cursor: pointer;
}
/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: grey;
  border-radius: 10px;
}
.pointer:hover {
  background-color: unset !important;
}
th.t-header {
  z-index: 2;
}
.clickable:hover {
  background-color: unset !important;
}
</style>
